import {
  AfterViewInit,
  Component,
  ContentChildren,
  Input,
  OnInit,
  forwardRef,
  inject
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { OptionComponent } from '../option/option.component';
import { SelectService } from '../select.service';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    },
    SelectService
  ],
  standalone: false
})
export class SelectComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  private selectService = inject(SelectService);

  @Input() placeholder: string;
  @Input() disabled = false;
  @Input() selected: any = null;
  showing = false;

  @ContentChildren(OptionComponent) options: OptionComponent[];
  selectedOption: OptionComponent;

  ngOnInit() {
    this.selectService.currentSelected.subscribe((selected) => {
      this.showing = false;
      this.selected = selected;
      this.onChange();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.selectedOption = this.options.find((option) => option.value === this.selected);
      this.selectService.displayText = this.selectedOption ? this.selectedOption.displayText : '';
    });
  }

  onChangeFn = (_: any) => {};

  onTouchedFn = () => {};

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.selectService.setSelect(obj);
  }

  onTouched() {
    this.onTouchedFn();
  }

  onChange() {
    this.onChangeFn(this.selected);
  }

  showDropdown() {
    if (!this.disabled) {
      this.showing = true;
    }
  }

  hideDropdown() {
    this.showing = false;
  }

  get displayText(): string {
    return this.selectService.displayText;
  }
}
